










































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'
import { CancelReason, EPromotionStatus, PromotionHistory } from '@/services/connecteur'
import serviceModule from '@/store/modules/ServiceModule'
import { DataRetourActionComponent } from '@/models/utils'
import CancelDialog from '@/components/Dialogs/CancelDialog.vue'
import ActionDialog from '@/components/Dialogs/ActionDialog.vue'
import HistoryDialog from '@/components/Dialogs/HistoryPromotionDialog.vue'
import userModule from '@/store/modules/UserModule'

@Component({
  components: {
    CancelDialog,
    ActionDialog,
    HistoryDialog
  }
})
export default class ActionComponent extends Mixins(BaseVue) {
  @Prop() loading!: boolean
  @Prop() statusActuelle!: EPromotionStatus
  @Prop() cmmfsAccepted!: boolean
  @Prop() cmmfFlagged!: boolean
  @Prop() cmmfFlaggedForBuCheck!: boolean
  @Prop() cmmfFlaggedForBuCheckAllAnswered!: boolean
  @Prop() SalesOrgIdPromotion!: number | undefined
  @Prop() KamIdPromotion!: number | undefined
  @Prop() AssistantKamIdPromotion!: number[] | undefined
  @Prop() isOnDemandPlannerList!: boolean
  @Prop() lockObtained!: boolean | null
  @Prop() history!: PromotionHistory[]

  public listOfPossibleReason: CancelReason[] = []
  public selectReason = 0
  public dialogPrevalidatedToApproved = false
  public dialogPrevalidatedToRework = false
  public dialogToBuCheck = false
  public dialogEndBuCheck = false
  public dialogtoDraft = false
  public dialogToAmmended = false
  public dialogToCancelled = false
  public dialogToHistory = false;

  public forceLockRelease () {
    this.$emit('send:forceLockRelease')
  }

  public sendToDraft () {
    this.$emit(
      'send:sendToSubmitKam',
      new DataRetourActionComponent(EPromotionStatus.DRAFT)
    )
  }

  public sendToPrevalidated () {
    this.$emit(
      'send:sendToSubmitDp',
      new DataRetourActionComponent(EPromotionStatus.PREVALIDATED)
    )
  }

  public sendToRework () {
    this.dialogPrevalidatedToRework = false
    this.$emit(
      'send:sendToSubmitDp',
      new DataRetourActionComponent(EPromotionStatus.REWORK)
    )
  }

  public sendToApproved () {
    this.$emit(
      'send:sendTo',
      new DataRetourActionComponent(EPromotionStatus.APPROVED)
    )
  }

  public sendToBuCheck () {
    this.$emit(
      'send:sendToSubmitDp',
      new DataRetourActionComponent(EPromotionStatus.BU_CHECK)
    )
  }

  public submitDpUpdate () {
    this.$emit('send:submitDpUpdate', null)
  }

  public submitSnpUpdate () {
    this.$emit('send:submitSnpUpdate', null)
  }

  public onSubmit () {
    this.$emit('send:submit', null)
  }

  public sendToChanged () {
    this.$emit(
      'send:sendToSubmitKam',
      new DataRetourActionComponent(EPromotionStatus.CHANGED)
    )
  }

  public sendToAmended () {
    this.dialogToAmmended = false
    this.$emit(
      'send:sendTo',
      new DataRetourActionComponent(
        EPromotionStatus.REWORK,
        this.selectReason
      )
    )
  }

  public endBuCheck () {
    this.dialogEndBuCheck = false
    this.$emit(
      'send:sendToSubmitSnp',
      new DataRetourActionComponent(EPromotionStatus.DRAFT)
    )
  }

  public sendToReworkNoUpdate () {
    this.$emit(
      'send:sendTo',
      new DataRetourActionComponent(EPromotionStatus.REWORK)
    )
  }

  public sendToCancelled (data: DataRetourActionComponent) {
    this.$emit('send:sendTo', data)
  }

  public get isStatusNew () {
    return this.statusActuelle === EPromotionStatus.NEW
  }

  public get isStatusRework () {
    return this.statusActuelle === EPromotionStatus.REWORK
  }

  public get isStatusDraft () {
    return this.statusActuelle === EPromotionStatus.DRAFT
  }

  public get isStatusBuCheck () {
    return this.statusActuelle === EPromotionStatus.BU_CHECK
  }

  public get isStatusPrevalidated () {
    return this.statusActuelle === EPromotionStatus.PREVALIDATED
  }

  public get isStatusChanged () {
    return this.statusActuelle === EPromotionStatus.CHANGED
  }

  public get isStatusCancelled () {
    return this.statusActuelle === EPromotionStatus.CANCELLED
  }

  public get isStatusApproved () {
    return this.statusActuelle === EPromotionStatus.APPROVED
  }

  public get isUserAdmin () {
    return userModule.isUserAdminOnSalesOrg(this.SalesOrgIdPromotion)
  }

  public get isUserKamOfThisPromotion () {
    return (
      this.isUserAdmin ||
      (userModule.userIsKAM &&
        userModule.id === this.KamIdPromotion) ||
      (userModule.userIsKAMAssistant &&
        this.AssistantKamIdPromotion?.includes(userModule.id as number))
    )
  }

  public get isUserKam () {
    return (
      this.isUserAdmin ||
      ((userModule.userIsKAM || userModule.userIsKAMAssistant) &&
        this.isStatusNew)
    )
  }

  public get isUserDpOfThisPromotion () {
    return (
      this.isUserAdmin ||
      (userModule.userIsDemandPlanner && this.isOnDemandPlannerList)
    )
  }

  public get isUserSnp () {
    return this.isUserAdmin ||
      userModule.userIsSNP
  }

  public get canSaveBuCheck () {
    return this.statusActuelle === EPromotionStatus.BU_CHECK &&
      this.isUserSnp
  }

  public get canEndBuCheck () {
    return this.canSaveBuCheck &&
      this.cmmfFlaggedForBuCheckAllAnswered
  }

  public get canCancelPromotion () {
    // Vérification générique.
    const userHaveRight =
      (userModule.userIsKAM &&
        userModule.id === this.KamIdPromotion) ||
      (userModule.userIsKAMAssistant &&
        this.AssistantKamIdPromotion?.includes(userModule.id as number)) ||
      this.isUserAdmin
    const isStatusUndoable =
      this.statusActuelle === EPromotionStatus.NEW ||
      this.statusActuelle === EPromotionStatus.REWORK ||
      this.statusActuelle === EPromotionStatus.CHANGED ||
      this.statusActuelle === EPromotionStatus.DRAFT ||
      this.statusActuelle === EPromotionStatus.BU_CHECK ||
      this.statusActuelle === EPromotionStatus.PREVALIDATED ||
      this.statusActuelle === EPromotionStatus.APPROVED

    return isStatusUndoable && userHaveRight
  }

  @Watch('SalesOrgIdPromotion')
  public updateSalesOrgIdPromotion () {
    serviceModule.cancelReasonApi
      .getCancelReasons(this.SalesOrgIdPromotion)
      .then((response: CancelReason[]) => {
        this.listOfPossibleReason = response
      })
      .catch(err => {
        this.displayError(err)
      })
  }
}
